const Marital_Statuses = ["SINGLE", "MARRIED", "DIVORCED", "COMMON LAW MARRIAGE"];

export const MARITAL_STATUSES = Marital_Statuses;

const Marital_Status = {
	single: "SINGLE",
	married: "MARRIED",
	divorced: "DIVORCED",
	common_law_marriage: "COMMON LAW MARRIAGE"
};

export const MARITAL_STATUS = Marital_Status;
